import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://wattandwattle.com.au';

const DEFAULT_META = {
  title: 'Solar Panels & Battery Systems Melbourne (Vic) | Watt & Wattle',
  description: 'Watt & Wattle provides solar & battery solutions in Melbourne for homes and businesses. Get tailored systems, expert installation, & support. Get a quote.',
};

const PAGE_META = {
  '/': DEFAULT_META,
  '/residential-solutions': {
    title: 'Residential Solar & Battery Melbourne | Watt & Wattle',
    description: 'Upgrade with household solar panels and batteries for home energy needs. Watt & Wattle provides tailored systems across Melbourne. Get a free quote.',
  },
  '/commercial-solutions': {
    title: 'Commercial Solar Solutions Melbourne | Watt & Wattle',
    description: 'Watt & Wattle provides tailored solar and battery systems for Melbourne businesses, helping manage energy costs with reliable solutions. Get a quote.',
  },
  '/why-us': {
    title: 'About Us | Solar Power Company Melbourne | Watt & Wattle',
    description: 'See why Melbourne customers choose Watt & Wattle for solar and battery solutions, tailored systems, quality products and expert installation. Contact us.',
  },
  '/contact': {
    title: 'Contact Us | Solar Installers Melbourne | Watt & Wattle',
    description: 'Looking for solar or battery installation in Melbourne? Watt & Wattle provides solutions for residential and commercial properties. Get a free quote today.',
  },
  '/blog': {
    title: 'Solar Panel & Battery Tips Melbourne | Watt & Wattle Blog',
    description: "Explore Watt & Wattle's blog for solar panel and battery storage guides, energy-saving tips and rebate updates for Melbourne homes and businesses.",
  },
};

// Set document title, meta description and canonical URL per route (SPA)
function PageMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
    const { title, description } = PAGE_META[path] || DEFAULT_META;

    document.title = title;

    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', 'description');
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', description);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', SITE_URL + path);
  }, [pathname]);

  return null;
}

export default PageMeta;
